import React, { useEffect, useState } from "react";
import { IsEmpty } from "../../helpers/HelperFunctions";
import ModularContentProcessor from "../StructuredContent/ModularContentProcessor.js";

// Custom hook to check if the component has mounted
// This is used to ensure that the script is only loaded after the component has mounted
function useHasMounted() {
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    return hasMounted;
}

export default function LayoutQuiz(props) {
    const hasMounted = useHasMounted();

    useEffect(() => {
        if (hasMounted && !IsEmpty(props.iFrameLink?.value)) {
            const iframeLink = props.iFrameLink.value;
            const script = document.createElement("script");

            // determine which riddle script to load: v1 or v2
            let scriptUrl = "https://www.riddle.com/embed/files/js/embed.js";

            if (iframeLink.includes("build-embedjs")) {
                scriptUrl = "https://www.riddle.com/embed/build-embedjs/embedV2.js";
            }

            // check if the script is already loaded
            script.src = scriptUrl;
            script.async = true;
            document.body.appendChild(script);
        }
    }, [hasMounted, props.iFrameLink]);

    if (!hasMounted || IsEmpty(props.iFrameLink)) return null;

    const wrapperclass = props.oddEvenDisplay === "Rm-Blue-Background" ? "ou-rm-blue-background" : "ou-quiz-wrapper";
    return (
        <section className={wrapperclass}>
            <div className="ou-quiz-container">
                {!IsEmpty(props.title?.value) && (
                    <h3 className="ou-quiz-title">{props.title.value}</h3>
                )}

                {!IsEmpty(props.body?.value) && (
                    <ModularContentProcessor
                        richText={props.body}
                        layoutSection="quizDescription"
                    />
                )}

                <div
                    className="ou-quiz-iframe-container"
                    dangerouslySetInnerHTML={{ __html: props.iFrameLink.value }}
                />
            </div>
        </section>
    );
}
